
    import { defineComponent } from 'vue'
    import AccentColour from '@/models/AccentColour'
    import LogoComponent from "@/components/LogoComponent.vue"

    export default defineComponent ({
        name: "HeaderComponent",
        data() {
            return {
                AccentColour
            }
        },
        components: {
            LogoComponent
        }
    })
